import React, { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Package, Settings, ShoppingBag } from 'lucide-react';
import ListaProductosAdmin from '../components/tienda/admin/ListaProductosAdmin';
import EditorProducto from '../components/tienda/admin/EditorProducto';
import AjustesTienda from '../components/tienda/admin/AjustesTienda';

const PESTANAS = [
  { id: 'productos', label: 'Productos', icon: Package },
  { id: 'ajustes', label: 'Pago y envío', icon: Settings },
];

export default function TiendaOnlineAdmin() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const activa = params.get('tab') === 'ajustes' ? 'ajustes' : 'productos';
  const editando = params.get('producto');
  const cerrar = useCallback(() => setParams({}), [setParams]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="tienda-admin-page">
      <header className="sticky top-0 z-20 bg-white shadow-sm">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-4">
          <button onClick={() => navigate('/dashboard')} className="rounded-lg p-2 transition hover:bg-slate-100" aria-label="Volver" data-testid="tienda-admin-volver"><ArrowLeft className="h-5 w-5" /></button>
          <div className="min-w-0">
            <h1 className="flex items-center gap-2 text-xl font-bold text-slate-800"><ShoppingBag className="h-6 w-6 text-amber-600" />Tienda online Mi JPM</h1>
            <p className="text-sm text-slate-500">Productos que tus clientes pueden personalizar y comprar desde Mi JPM.</p>
          </div>
        </div>
        <nav className="mx-auto flex max-w-6xl gap-1 px-4" data-testid="tienda-admin-pestanas">
          {PESTANAS.map(({ id, label, icon: Icon }) => (
            <button key={id} onClick={() => setParams({ tab: id })} data-testid={`tienda-admin-tab-${id}`}
              className={`inline-flex items-center gap-2 border-b-2 px-3 py-3 text-sm font-medium transition-colors ${activa === id ? 'border-slate-800 text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-800'}`}>
              <Icon className="h-4 w-4" />{label}
            </button>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-6">
        {activa === 'ajustes' && <AjustesTienda />}
        {activa === 'productos' && (editando
          ? <EditorProducto key={editando} productoId={editando} onCerrar={cerrar} onCreado={id => setParams({ producto: id })} />
          : <ListaProductosAdmin onEditar={id => setParams({ producto: id })} />)}
      </main>
    </div>
  );
}
